(() => {
  const ttl = 30 * 60 * 1000;
  const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  const paths = { contact: '/pages/contact', investment_information: '/pages/investment-information', investment_information_es: '/pages/investment-information-es', investment_information_pt: '/pages/investment-information-pt', investment_information_fr: '/pages/investment-information-fr', investment_information_nl: '/pages/investment-information-nl' };
  const clickKeys = ['gclid', 'gbraid', 'wbraid'];
  const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_id', 'utm_source_platform', 'utm_content', 'utm_term'];
  const cleanLanding = (value, path) => {
    try {
      const url = new URL(value);
      if (url.protocol !== 'https:' || url.username || url.password || url.port ||
          !['finchcliffadvisory.com', 'www.finchcliffadvisory.com'].includes(url.hostname) ||
          url.pathname.replace(/\/$/, '') !== path ||
          ['preview_theme_id', 'preview_script_id', 'webPixelDebug'].some(key => url.searchParams.has(key))) return null;
      const safe = new URL(url.origin + path);
      for (const key of [...clickKeys, ...utmKeys]) {
        const values = url.searchParams.getAll(key);
        if (values.length !== 1) continue;
        const valid = clickKeys.includes(key) ? /^[A-Za-z0-9_-]{1,512}$/.test(values[0])
          : /^[\p{L}\p{M}\p{N} _.,:|\/-]{1,100}$/u.test(values[0]);
        if (valid) safe.searchParams.set(key, values[0]);
        if (safe.href.length > 1000) safe.searchParams.delete(key);
      }
      return safe.href;
    } catch { return null; }
  };
  const productionContext = () => {
    const path = window.location.pathname.replace(/\/$/, '');
    return Object.values(paths).includes(path) && cleanLanding(window.location.href, path) !== null &&
      window.Shopify?.designMode !== true && !document.getElementById('preview-bar-iframe');
  };
  const hasConsent = () => {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      const consent = privacy?.currentVisitorConsent?.();
      return (consent?.analytics === 'yes' && privacy.analyticsProcessingAllowed?.() === true) ||
        (consent?.marketing === 'yes' && privacy.marketingAllowed?.() === true);
    } catch { return false; }
  };
  const isTest = form => {
    const value = name => String(form.elements.namedItem(name)?.value || '').trim();
    return value('contact[email]').toLowerCase() === 'enquiries@finchcliffadvisory.com' ||
      /INTERNAL TECHNICAL TEST|NOT AN INVESTOR ENQUIRY|FC_FORM_TEST|FC_INFO_TEST|TEST GA4 operator/i.test(
        [value('contact[name]'), value('contact[body]'), value('contact[Message]')].join(' ')
      );
  };
  const attach = form => {
    const path = window.location.pathname.replace(/\/$/, '');
    const formType = form.dataset.finchcliffFormType || 'contact';
    if (!form.id || form.dataset.finchcliffEnquiryBound === 'true' ||
        paths[formType] !== path || !productionContext()) return;
    form.dataset.finchcliffEnquiryBound = 'true';
    const key = 'finchcliff:enquiry:v2:' + encodeURIComponent(form.id) + ':' + encodeURIComponent(path);
    const clear = () => {
      try { window.sessionStorage.removeItem(key); return window.sessionStorage.getItem(key) === null; }
      catch { return false; }
    };
    let pendingTimer;
    form.addEventListener('invalid', () => { clear(); window.clearTimeout(pendingTimer); }, true);
    form.addEventListener('submit', event => {
      if (event.isTrusted !== true || !form.checkValidity() || !productionContext()) return;
      window.clearTimeout(pendingTimer);
      const notice = form.querySelector('[data-finchcliff-pending]');
      if (notice) {
        notice.hidden = true;
        pendingTimer = window.setTimeout(() => { notice.hidden = false; }, 20000);
      }
      if (!clear() || !hasConsent() || typeof window.crypto?.randomUUID !== 'function') return;
      try {
        const nonce = window.crypto.randomUUID();
        if (!uuid.test(nonce)) return;
        const pending = JSON.stringify({
          nonce, createdAt: Date.now(), formId: form.id, path,
          test: isTest(form), landingPage: cleanLanding(window.location.href, path)
        });
        window.sessionStorage.setItem(key, pending);
        if (window.sessionStorage.getItem(key) !== pending) clear();
      } catch { clear(); }
    }, true);
    const success = form.querySelector('.contact-form__success[data-finchcliff-server-confirmed="true"]');
    if (form.querySelector('.contact-form__error') || !success) { clear(); return; }
    const confirm = () => {
      let pending;
      try { pending = JSON.parse(window.sessionStorage.getItem(key)); }
      catch { clear(); return; }
      if (!clear()) return;
      if (!pending || pending.formId !== form.id || pending.path !== path ||
          !uuid.test(pending.nonce) || !Number.isFinite(pending.createdAt) ||
          Date.now() < pending.createdAt || Date.now() - pending.createdAt > ttl || !productionContext()) {
        success.dataset.finchcliffTrackingState = 'no_valid_submission';
        return;
      }
      if (pending.test === true) { success.dataset.finchcliffTrackingState = 'test_excluded'; return; }
      if (!hasConsent()) { success.dataset.finchcliffTrackingState = 'consent_not_granted'; return; }
      window.FinchcliffMeta?.trackLead(pending.nonce);
      if (typeof window.Shopify?.analytics?.publish !== 'function') {
        success.dataset.finchcliffTrackingState = 'publisher_unavailable';
        return;
      }
      try {
        const result = window.Shopify.analytics.publish('finchcliff_enquiry_confirmed', {
          confirmed: true, form_id: formType, event_id: pending.nonce,
          landing_page: cleanLanding(pending.landingPage, path)
        });
        success.dataset.finchcliffTrackingState = 'published';
        if (result && typeof result.catch === 'function') {
          result.catch(() => { success.dataset.finchcliffTrackingState = 'publisher_failed'; });
        }
      } catch { success.dataset.finchcliffTrackingState = 'publisher_failed'; }
    };
    if (window.Shopify?.customerPrivacy) confirm();
    else if (typeof window.Shopify?.loadFeatures === 'function') {
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
          if (error) clear(); else confirm();
        });
      } catch { clear(); }
    } else clear();
  };
  const initialize = () => {
    document.querySelectorAll('.contact-form__form').forEach(attach);
    if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
      try { window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {}); }
      catch {}
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
